export const STATUS_ERROR = 'ERROR';
export const STATUS_OK = 'OK';
export const STATUS_PENDING = 'PENDING';



// WEBPACK FOOTER //
// ./src/constants/reponseTypes.js